<template>
  <div>
    <el-row class="form-item">
      <el-col :span="2">
        <span class="required-text">*</span>收货地址
      </el-col>
      <el-col :span="16">
        <div class="address-radio">
          <el-radio-group>
            <el-radio-group v-model="addressNum">
              <el-radio :label="1">系统默认地址</el-radio>
              <el-radio :label="0">上传发货明细</el-radio>
            </el-radio-group>
          </el-radio-group>
        </div>
      </el-col>
      <el-col>
        <div v-if="addressNum">
          <el-row class="apply-person">
            <el-col :span="2">
              <span class="required-text">*</span>申请人
            </el-col>
            <el-col :span="4">
              <el-input v-model="applyPerson" clearable placeholder="申请人姓名"></el-input>
            </el-col>
            <el-col :span="19" :offset="0">
              <div class="create-text" @click="toAdd">新建地址</div>
            </el-col>
          </el-row>
          <!-- <el-cascader v-model="sdAddress" :options="addressOptions" :props="{ expandTrigger: 'hover' }" clearable @change="setAddress" size="middle" style="width: 550px" /> -->

          <el-row
            class="addressList"
            :class="{addressListBorder: index+1 != addressMaterialList.length}"
            v-for="(item, index) in addressMaterialList"
            :key="index"
          >
            <el-col :span="2" style="line-height:40px">
              <span class="required-text">*</span>
              收货地址{{index + 1}}
            </el-col>
            <el-col :span="14">
              <el-select v-model="item.clientAddressId" placeholder="收货地址" clearable filterable style="width: 100%; margin-bottom: 10px">
                <el-option v-for="item in addressList" :label="item.fullAddress" :value="item.addressId" :key="item.addressId" />
              </el-select>
            </el-col>
            <span class="danger-btn el-icon-remove-outline" v-if="addressMaterialList.length > 1" @click="delAddress(index)"></span>
            <span class="addAddress el-icon-circle-plus-outline" @click="addAddress"></span>
            <el-col
              :span="20"
              :offset="2"
              style=" margin-bottom: 10px"
              v-for="(material, materialIndex) in item.material"
              :key="materialIndex"
            >
              <template v-if="addressMaterialList.length > 1">
                <span class="required-text">*</span>
                物料{{materialIndex + 1}}
                <el-select v-model="material.materialCode" placeholder="选择物料" clearable filterable style="width: 350px; margin-right: 20px">
                  <el-option
                    v-for="item in orderItemList"
                    :label="item.pocmDTO.itemName"
                    :value="item.itemCode"
                    :key="item.pocmDTO.itemName"
                  />
                </el-select>
                <span class="required-text">*</span>数量
                <el-input-number class="Stepper" v-model="material.materialQuantity" placeholder="填写物料数量" :min="1"></el-input-number>

                <i class="el-icon-circle" v-if="item.material.length !== 1" @click="delMaterial(index, materialIndex)" style="color:#c8102d">删除</i>
                <span v-if="item.material.length !== 1">&nbsp;|&nbsp;</span>
                <i class="el-icon-circle" @click="addMaterial(index)" style="color:#2185D0;">增加</i>
              </template>
            </el-col>
          </el-row>
        </div>
        <div v-else class="import-btn">
          <div>
            <el-button class="btn-grey-plain" @click="handleExport">下载物流发货明细模版</el-button>
          </div>
          <div>
            <FileUpload
              ref="dataFileUpload"
              :upload-param="{ filePath: 'temp' }"
              show-type="text"
              @uploaded="getDataFile"
              @removed="clearDataFile"
              :isClearFile="isClear"
            >
              <el-button class="btn-blue-plain">上传物流发货明细文档</el-button>
            </FileUpload>
          </div>
        </div>
      </el-col>
    </el-row>
    <ItemOrderAddressList v-if="isImport" :orderAddressList="deliveryAddress" />
    <AddressForm ref="address-form" @success="getAddressList" />
  </div>
</template>

<script>
import userApi from '@/api/user'
import { commonUtils } from '@/utils/common'
import AddressForm from '../../user/components/address-form'
import FileUpload from '@/components/file-upload'
import ItemOrderAddressList from './item-order-address-list'
export default {
  props: {
    orderItemList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  name: 'ItemOrderAddress',
  components: {
    FileUpload,
    ItemOrderAddressList,
    AddressForm
  },
  data () {
    return {
      addressList: [],
      addressSelected: {},
      dialogVisible: false,
      actived: {},
      params: '',
      addressNum: 1,
      orderFileId: '',
      deliveryAddress: [],
      isImport: false,
      isClear: false,
      applyPerson: '',
      clientAddressId: '',
      addressMaterialList: [
        {
          clientAddressId: '', // 收货地址
          material: [
            {
              materialCode: '', // 物料编号
              materialQuantity: undefined // 物料数量
            }
          ]
        }
      ]
    }
  },
  watch: {
    addressNum (val) {
      this.deliveryAddress = []
      this.clientAddressId = ''
      this.isImport = false
      this.setAddress()
      this.setAddressNum()
    }
  },
  // computed: {
  //   ...mapState({
  //     addressOptions: state => state.base.sdAddress
  //   })
  // },
  computed: {
    orderMaterialQuantity: function () {
      return this.getOrderMaterialQuantity()
    }

  },
  created () {
    // this.$store.dispatch('getSdAddress')
    this.getAddressList()
  },
  mounted () {

  },
  methods: {
    // 添加收货地址
    addAddress () {
      this.addressMaterialList.push({
        clientAddressId: '', // 收货地址
        material: [
          {
            materialCode: '', // 物料编号
            materialQuantity: undefined // 物料数量
          }
        ]
      })
    },
    // 删除收货地址
    delAddress (index) {
      if (this.addressMaterialList.length === 1) {
        return
      }
      this.addressMaterialList.splice(index, 1)
    },
    // 添加物料信息
    addMaterial (index) {
      this.addressMaterialList[index].material.push({
        materialCode: '',
        materialQuantity: undefined
      })
    },
    // 删除物料信息
    delMaterial (index, materialIndex) {
      if (this.addressMaterialList[index].material.length === 1) {
        return
      }
      this.addressMaterialList[index].material.splice(materialIndex, 1)
    },
    // 获取订单商品数量
    getOrderMaterialQuantity () {
      let orderMaterialQuantity = {}
      for (const i of this.orderItemList) {
        orderMaterialQuantity[i.pocmDTO.itemCode] = i.itemQuantity
      }

      return orderMaterialQuantity
    },

    maskMobileNo: commonUtils.maskMobileNo,

    // 下载模版
    handleExport () {
      this.$emit('handleExport')
    },

    // 获取地址
    getAddressList () {
      userApi.queryAddressList().then((res) => {
        if (res.data.resultCode === '0') {
          this.addressList = res.data.resultData.addressList
          this.addressList.forEach((item) => {
            let fullAddress = `${item.provinceName}-${item.cityName}-${item.countyName}-${item.detailAddress}，收货人：${item.contactPerson} ${item.contactMobile}`
            this.$set(item, 'fullAddress', fullAddress)
          })
        }
      })
    },

    // 上传文件
    getDataFile (file) {
      this.isClear = false
      this.orderFileId = file.fileId
      this.importOrder()
      this.setFileId()
    },

    // 订单交付数据导入
    importOrder () {
      let params = {
        dataFileId: this.orderFileId,
        generateDetail: 0
      }
      this.$store.dispatch('importOrder', params).then((res) => {
        if (res.data.resultCode === '0') {
          this.$message.success('物流发货明细上传成功')
          this.isClear = false
          this.deliveryAddress = res.data.resultData.deliveryList
          this.isImport = true
          this.setAddress()
        } else {
          this.isClear = true
          this.clearDataFile()
        }
      })
    },

    setFileId () {
      this.$emit('setFileId', this.orderFileId)
    },
    // 验证地址物料信息
    checkAddressMaterial () {
      if (this.addressMaterialList.length > 1) {
        let tmpAddressMaterial = []
        let tmpQuantity = {}
        for (let i = 0; i < this.addressMaterialList.length; i++) {
          let tmpItem = {}
          tmpItem.material = []
          if (this.addressMaterialList[i].clientAddressId) {
            tmpItem.clientAddressId = this.addressMaterialList[i].clientAddressId
            // for (const j of this.addressMaterialList[i].material) {
            //   if (j.materialCode) {
            //     tmpQuantity[j.materialCode] = tmpQuantity[j.materialCode] || 0
            //     tmpQuantity[j.materialCode] += j.materialQuantity
            //     tmpItem.material.push(j)
            //     if (!j.materialQuantity) {
            //       this.$message.error(`请填写收货地址 ${i + 1} 下物料数量`)
            //       return false
            //     }
            //   } else {
            //     this.$message.error(`请填写收货地址 ${i + 1} 下物料信息`)
            //     return false
            //   }
            // }
            for (let j = 0; j < this.addressMaterialList[i].material.length; j++) {
              if (this.addressMaterialList[i].material[j].materialCode) {
                tmpQuantity[this.addressMaterialList[i].material[j].materialCode] = tmpQuantity[this.addressMaterialList[i].material[j].materialCode] || 0
                tmpQuantity[this.addressMaterialList[i].material[j].materialCode] += this.addressMaterialList[i].material[j].materialQuantity
                tmpItem.material.push(this.addressMaterialList[i].material[j])
                if (!this.addressMaterialList[i].material[j].materialQuantity) {
                  this.$message.error(`请填写收货地址 ${i + 1} 下物料 ${j + 1} 数量`)
                  return false
                }
              } else {
                this.$message.error(`请填写收货地址 ${i + 1} 下物料 ${j + 1} 信息`)
                return false
              }
            }
          } else {
            this.$message.error(`收货地址 ${i + 1} 为空`)
            return false
          }
          if (tmpItem.material.length) {
            tmpAddressMaterial.push(tmpItem)
          }
        }
        // if (!tmpAddressMaterial.length) {
        //   this.$message.error('请检查地址物料信息')
        //   return false
        // }
        for (const item in this.orderMaterialQuantity) {
          if (tmpQuantity[item] !== this.orderMaterialQuantity[item]) {
            this.orderItemList.forEach(orderItem => {
              if (orderItem.itemCode === item) {
                this.$message.error(`请检查 ${orderItem.pocmDTO.itemName} 数量`)
              }
            })
            return false
          }
        }
        this.addressMaterialList = tmpAddressMaterial
      } else if (!this.addressMaterialList[0].clientAddressId) {
        this.$message.error('收货地址为空')
        return false
      }
      this.composeValue()
      // console.log(this.deliveryAddress)
      this.setAddress()
      return true
    },
    // 组装数据
    composeValue () {
      this.deliveryAddress = []
      let recordList = []
      // 单地址
      if (this.addressMaterialList.length === 1) {
        if (this.addressMaterialList[0].clientAddressId) {
          let tmpAddressMaterial = {}
          let addressInfo = this.addressList.filter(address => {
            return this.addressMaterialList[0].clientAddressId === address.addressId
          })[0]
          tmpAddressMaterial.addressId = addressInfo.addressId
          tmpAddressMaterial.applyPerson = this.applyPerson
          tmpAddressMaterial.receivePerson = addressInfo.contactPerson
          tmpAddressMaterial.receivePhone = addressInfo.contactMobile
          tmpAddressMaterial.provinceName = addressInfo.provinceName
          tmpAddressMaterial.cityName = addressInfo.cityName
          tmpAddressMaterial.countyName = addressInfo.countyName
          tmpAddressMaterial.detailAddress = addressInfo.detailAddress
          this.orderItemList.forEach(orderItem => {
            let tmpObj = JSON.parse(JSON.stringify(tmpAddressMaterial))
            tmpObj.itemName = orderItem.pocmDTO.itemName
            tmpObj.itemCode = orderItem.itemCode
            tmpObj.purchaseQuantity = orderItem.itemQuantity
            tmpObj.mmr12 = orderItem.mmr12
            tmpObj.ledgerAccount = orderItem.ledgerAccount
            tmpObj.abiBrandName = orderItem.abiBrandName
            tmpObj.abiBrandId = orderItem.abiBrandId
            tmpObj.subBrandName = orderItem.subAbiBrandName
            tmpObj.subBrandId = orderItem.subBrandId
            this.deliveryAddress.push(tmpObj)
          })
        }
      } else {
        // 多地址
        this.addressMaterialList.forEach(item => {
          if (recordList.includes(item.clientAddressId)) {
            item.material.forEach(materialItem => {
              if (materialItem.materialCode) {
                let tmpMaterial = false
                this.deliveryAddress.forEach(deliveryItem => {
                  if (deliveryItem.itemCode === materialItem.materialCode && deliveryItem.addressId === item.clientAddressId) {
                    deliveryItem.purchaseQuantity += materialItem.materialQuantity ?? 0
                    tmpMaterial = true
                  }
                })
                if (!tmpMaterial) {
                  this.composeMaterial(item, recordList)
                }
              }
            })
          } else {
            this.composeMaterial(item, recordList)
          }
        })
      }
    },
    composeMaterial (item, recordList) {
      let tmpAddressMaterial = {}
      if (item.clientAddressId) {
        let addressInfo = this.addressList.filter(address => {
          return item.clientAddressId === address.addressId
        })[0]
        tmpAddressMaterial.addressId = addressInfo.addressId
        tmpAddressMaterial.applyPerson = this.applyPerson
        tmpAddressMaterial.receivePerson = addressInfo.contactPerson
        tmpAddressMaterial.receivePhone = addressInfo.contactMobile
        tmpAddressMaterial.provinceName = addressInfo.provinceName
        tmpAddressMaterial.cityName = addressInfo.cityName
        tmpAddressMaterial.countyName = addressInfo.countyName
        tmpAddressMaterial.detailAddress = addressInfo.detailAddress
        let tmpList = []
        item.material.forEach(materialItem => {
          if (materialItem.materialCode) {
            if (tmpList.includes(materialItem.materialCode)) {
              this.deliveryAddress.forEach(deliveryItem => {
                if (deliveryItem.itemCode === materialItem.materialCode && deliveryItem.addressId === item.clientAddressId) {
                  deliveryItem.purchaseQuantity += materialItem.materialQuantity ?? 0
                }
              })
            } else {
              let tmpObj = JSON.parse(JSON.stringify(tmpAddressMaterial))
              this.orderItemList.forEach(orderItem => {
                if (materialItem.materialCode === orderItem.itemCode) {
                  tmpObj.itemName = orderItem.pocmDTO.itemName
                  tmpObj.itemCode = orderItem.itemCode
                  tmpObj.purchaseQuantity = materialItem.materialQuantity
                  tmpObj.mmr12 = orderItem.mmr12
                  tmpObj.ledgerAccount = orderItem.ledgerAccount
                  tmpObj.abiBrandName = orderItem.abiBrandName
                  tmpObj.abiBrandId = orderItem.abiBrandId
                  tmpObj.subBrandName = orderItem.subAbiBrandName
                  tmpObj.subBrandId = orderItem.subBrandId
                  this.deliveryAddress.push(tmpObj)
                  tmpList.push(materialItem.materialCode)
                }
              })
            }
          }
        })
      }
      recordList.push(item.clientAddressId)
    },

    setAddress () {
      let value = {
        clientAddressId: this.clientAddressId, // 客户地址
        applyPerson: this.applyPerson, // 申请人
        deliveryAddress: this.deliveryAddress // 送货地址
      }
      this.$emit('setAddress', value)
    },

    setAddressNum () {
      this.$emit('setAddressNum', this.addressNum)
    },

    clearDataFile (file) {
      this.orderFileId = ''
      this.setFileId()
      this.deliveryAddress = []
      this.isImport = false
    },

    toAdd () {
      const addressForm = { action: 'create' }
      this.$refs['address-form'].show(addressForm)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  // height: 210px;
  padding-top: $content-large;
  padding-bottom: $content-large;
  .address-item {
    margin-bottom: 10px;
    label {
      display: inline-block;
      width: 80px;
    }
  }
  .btn-orange {
    margin-top: $content-middle;
  }
  .import-btn {
    margin-top: $content-large;
    div + div {
      margin-top: 10px;
    }
  }
}
.address-list {
  .addrss-row {
    height: 320px;
    overflow-y: auto;
  }
  .address-card {
    padding: 16px 24px;
    min-height: 80px;
    margin-bottom: 20px;

    ::v-deep .el-card__body {
      padding: 0;
      min-height: 80px;
      cursor: pointer;
    }
    .address-info {
      line-height: 28px;
    }
    .address-opt {
      padding: 24px 0 0 16px;
    }
    .info-row {
      margin-bottom: 10px;
    }
  }

  .address-selected {
    // background-color: $base-grey3;
    border-color: $base-red;
  }
}
.btn-row {
  text-align: center;
}
.create-text {
  color: $base-blue;
  cursor: pointer;
  margin-top: 10px;
  margin-left: 7px;
  font-size: 12px;
  line-height: 40px;
  // position: absolute;
  // left: 5px;
  // top: 110px;
  z-index: 2;
}
.apply-person {
  line-height: 40px;
  margin-bottom: 10px;
  position: relative;
}
el-input-number {
  border: none !important;
}
.addressList {
  // padding-bottom: 30px;
  margin-bottom: 10px;
}
.addressListBorder {
  // border-bottom: 1px dashed #d3d3d3;
  &::after {
    content: '';
    width: 70%;
    margin-left: 95px;
    border-bottom: 1px dashed #d3d3d3;
  }
}
.danger-btn {
  cursor: pointer;
  margin-left: 25px;
  line-height: 40px;
  font-size: 26px;
  color: #c8102d;
}
.addMaterialbtn {
  position: relative;
  right: -200px;
}
.el-icon-plus {
  font-size: 30px;
  color: #3d9dff;
  position: relative;
  left: -350px;
  top: 45px;
  cursor: pointer;
}
.el-icon-minus {
  font-size: 30px;
  color: #3d9dff;
  position: relative;
  left: 55px;
  top: 4px;
  cursor: pointer;
}
.el-icon-circle {
  font-size: 12px;
  // margin-left: 20px;
  cursor: pointer;
}
.el-input-number {
  width: 110px;
}
.Stepper {
  margin-left: 5px;
  margin-right: 20px;
  border-color: white;
  ::v-deep .el-input__inner {
    width: 110px;
    padding: 0;
  }
  ::v-deep .el-input-number__decrease,
  ::v-deep .el-input-number__increase {
    display: none;
  }
}
.addAddress {
  cursor: pointer;
  color: $base-blue;
  line-height: 40px;
  font-size: 26px;
  margin-left: 5px;
}
</style>
